import { SET_SO_DISPLAY_ID, SET_SO_CUSTOMER_ID, SET_SO_PRODUCTS, SET_SO_DATE, SET_SO_STATUS, SET_SO_TOTAL, SET_SO_PAYMENTS, SET_SO_ACTIVE_STEP, SET_NEW_SO_INFO, CLEAR_NEW_SO } from 'redux/actionTypes';

const initialState = {
    displayId: "",
    customerId: 0,
    soProducts: [],
    startDate: null,
    endDate: null,
    status: "",
    total: 0,
    payments: [],
    activeStep: 0
};

export default function  newSalesOrder(state = initialState, action) {
    switch(action.type) {
        case SET_SO_DISPLAY_ID:
            return {
                ...state,
                displayId: action.payload
            };
        case SET_SO_CUSTOMER_ID:
            return {
                ...state,
                customerId: action.payload
            };
        case SET_SO_PRODUCTS:
            return {
                ...state,
                soProducts: action.payload
            };
        case SET_SO_DATE:
            return {
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate
            };
        case SET_SO_STATUS:
            return {
                ...state,
                status: action.payload
            };
        case SET_SO_TOTAL:
            return {
                ...state,
                total: action.payload
            };
        case SET_SO_PAYMENTS:
            return {
                ...state,
                payments: action.payload
            };
        case SET_SO_ACTIVE_STEP:
            return {
                ...state,
                activeStep: action.payload
            };
        case SET_NEW_SO_INFO:
            return {
                displayId: action.payload.displayId,
                customerId: action.payload.customerId,
                soProducts: action.payload.soProducts,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                status: action.payload.status,
                total: action.payload.total,
                payments: action.payload.payments,
                activeStep: 0
            };
        case CLEAR_NEW_SO:
            return {
                displayId: "",
                customerId: 0,
                soProducts: [],
                startDate: null,
                endDate: null,
                status: "",
                total: 0,
                payments: [],
                activeStep: 0
            };
        default:
            return state;
    }
};